(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vibe-offers-lite"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vibe-offers-lite')){
customElements.define('vibe-offers-lite',class extends HTMLElement{
 connectedCallback(){this.initId=setTimeout(()=>this.init(),0)}
 init(){for(const badge of this.querySelectorAll('[data-preview-left]')){
 const max=Number(badge.dataset.previewLeft);if(!Number.isSafeInteger(max)||max<1)continue;
 const key='vibe:preview:'+badge.dataset.key+':'+max;
 const visits=window.__vibePreviewNumbers??=new Map();let n=visits.get(key);
 if(n===undefined){try{const prev=Number(localStorage.getItem(key));
 n=prev>=1&&prev<=max?Math.max(1,prev-1-Math.floor(Math.random()*Math.min(2,prev-1))):1+Math.floor(Math.random()*max);
 localStorage.setItem(key,String(n))}catch{n=max}visits.set(key,n)}
 badge.textContent=n+' left · demo';
 }this.life=new AbortController();const opts={signal:this.life.signal};
 this.addEventListener('click',async e=>{const b=e.target.closest('button[data-code]');if(!b)return;const code=b.dataset.code;let ok=false;try{await navigator.clipboard.writeText(code);ok=true}catch{const t=document.createElement('textarea');t.value=code;t.style.cssText='position:fixed;left:-9999px';this.append(t);t.select();try{ok=document.execCommand('copy')}catch{}t.remove();b.focus()}this.querySelector('.vol-message').textContent=ok?'Copied: '+code:'Select and copy: '+code},opts);
 const clock=this.querySelector('.vol-clock');if(!clock)return;const period=Number(clock.dataset.period),digits=clock.querySelectorAll('b');if(!Number.isFinite(period)||period<=0)return;
 const tick=()=>{clearTimeout(this.tickId);if(document.hidden)return;const now=Date.now(),left=period-Math.floor(now/1000)%period;
 [Math.floor(left/86400),Math.floor(left/3600)%24,Math.floor(left/60)%60,left%60].forEach((n,i)=>{let v=String(n).padStart(2,'0');if(digits[i].textContent!==v)digits[i].textContent=v});clock.hidden=false;this.tickId=setTimeout(tick,1000-now%1000+5)};
 document.addEventListener('visibilitychange',tick,opts);tick()}
 disconnectedCallback(){clearTimeout(this.initId);clearTimeout(this.tickId);this.life?.abort()}
})}
  } catch(e) { console.error(e); }
})();

})();
